import { EntInitialFilter } from "./initialFilter";

export class EntFarmOwnerFilter implements EntInitialFilter {
  fullName: string | null;
  createdTo: string | null;
  createdFrom: string | null;
  deleted: boolean = false;
  page: number;
  size: number;

  constructor() {
    this.page = 1;
    this.size = 30;
    this.fullName = null;
    this.createdTo = null;
    this.createdFrom = null;
  }
}
